import Wallet from './wallet_fill.svg';
import AccountIcon from './ic_baseline-account-circle.svg';
import MenuDotFill from './menu_dot_fill.svg';
import IconHeaderRkeeper from './i_rkeeper.svg';
import IconHeaderBooking from './i_booking.svg';
import IconHeaderCrm from './i_crm.svg';
import IconHeaderVideo from './i_video.svg';
import IconHeaderSetting from './i_setting.svg';
import IconPieChart from './pie_chart_2_fill.svg';
import IconBarChart from './bar_chart_fill.svg';
import IconCalendarClockFill from './calendar_clock_fill.svg';
import IconLineChartFill from './line_chart_fill.svg';
import IconSlideTrendFill from './slide_trend_fill.svg';
import IconSettings from './gear_2_fill.svg';
import IconPlusCircleFill from './add_circle_fill.svg';
import IconMinusCircleFill from './subtract_circle_fill.svg';
import IconMainCalendar from './calendar_2_fill.svg';
import IconHumanAddFill from './human_add_fill.svg';
import IconCloud from './CloudWSArrow.svg';
import IconSearchVect1 from './vect1.svg';
import IconSearchVect2 from './vect2.svg';
import IconSearchVect3 from './vect3.svg';
import IconSearchVect4 from './vect4.svg';
import IconArrowUp from './arrow_up.svg';
import IconArrowDown from './arrow-down.svg';
import CircleCheck from './CircleCheck.svg';
import CircleQuestion from './CircleQuestion.svg';
import CircleMissed from './CircleMissed.svg';
import DownloadFill from './iconDownload.svg';
import MailFill from './iconMail.svg';
import TagsFill from './iconTags.svg';
import ChartExample from './ImageChart.svg';
import RedTriangle from './RedTriangle.svg';
import Settings3dots from './Settings3dots.svg';
import OptionsLines from './OptionsLines.svg';
import ConfirmIcon from './confirmIcon.svg';
import DeclineIcon from './declineIcon.svg';
import AddGreyPlusInCircle from './addGreyPlusInCircle.svg';
import SocialBlock from './socialBlock.svg';
import ShelterGray from './ShelterGrey.svg';
import SocialIconVK from './SocialIconVK.svg';
import SocialIconInstagram from './SocialIconInstagram.svg';
import SocialIconTelegram from './SocialIconTelegram.svg';
import SocialIconSite from './SocialIconSite.svg';
import ArrowUpWhite from './ArrowUpWhite.svg';
import ArrowDownWhite from './ArrowDownWhite.svg';
import FilterReset from './filterReset.svg';
import MoreIcon from './MoreIcon.svg';
import AddWhitePlusInCircle from './addWhitePlusInCircle.svg';

export const Icons = {
    HeaderIcons: {
        IconHeaderRkeeper,
        IconHeaderBooking,
        IconHeaderCrm,
        IconHeaderVideo,
        IconHeaderSetting,
    },
    MoreIcon,
    IconHumanAddFill,
    IconPieChart,
    IconBarChart,
    IconCalendarClockFill,
    IconMainCalendar,
    IconLineChartFill,
    IconSlideTrendFill,
    IconSettings,
    Wallet,
    AccountIcon,
    MenuDotFill,
    IconPlusCircleFill,
    IconMinusCircleFill,
    IconCloud,
    IconSearchVect1,
    IconSearchVect2,
    IconSearchVect3,
    IconSearchVect4,
    IconArrowUp,
    FilterReset,
    IconArrowDown,
    CircleCheck,
    CircleQuestion,
    MailFill,
    DownloadFill,
    TagsFill,
    Settings3dots,
    RedTriangle,
    ChartExample,
    OptionsLines,
    ConfirmIcon,
    DeclineIcon,
    AddGreyPlusInCircle,
    AddWhitePlusInCircle,
    ShelterGray,
    ArrowDownWhite,
    ArrowUpWhite,
    CircleMissed,
    Social: {
        SocialBlock,
        SocialIconVK,
        SocialIconInstagram,
        SocialIconTelegram,
        SocialIconSite,
    },
};
